import type { FaireProductEntity } from "../../entity_types/product";

export const p_xnpu6ku5qh: FaireProductEntity = {
  token: "p_xnpu6ku5qh",
  type: "product",
  name: "Arkansas Razorbacks Enamel Logo Charm",
  brandToken: "b_emgllltle6",
  brandName: "Canvas Style",
  imageUrl: "https://cdn.faire.com/fastly/4ec2546dbd6d25f6b5d6cf2cd961a250d0fac034bae3eda516c63c502572afef.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.54,
  description: "Show your Razorback spirit with the Arkansas Razorbacks Enamel Logo Charm. This colorful enamel charm captures the essence of your team pride and makes a striking addition to your jewelry collection. Mix & Match and add this charm to our Charm Necklace or Bracelets to show off your unique style.\n\nDETAILS: \n18K Triple Gold Plated\n.5\"L x .75\"W",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:42.335Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
